import { tokenService } from './tokenService';

// Configuración de la API HTTP
export const API_CONFIG = {
  // URLs base para diferentes entornos
  baseURL: process.env.REACT_APP_API_BASE_URL_ANN_WEB_DEV || 'https://gf0itlqvj0.execute-api.us-east-1.amazonaws.com',
  
  // WebSocket URL - debe configurarse por ambiente
  websocketURL: process.env.REACT_APP_WEBSOCKET_URL || 'wss://1jt254ce09.execute-api.us-east-1.amazonaws.com/dev/',
  
  langGraphURL: process.env.REACT_APP_LANGGRAPH_URL || 'https://langgraph-service-test-1-ed45ba9e3d2d5f88bb9024fce145d1bc.us.langgraph.app',

  // Endpoints específicos
  // NOTA: El endpoint sendMessage tiene '/dev/' hardcodeado. 
  // Si staging/prod usan diferentes rutas, esto debería ser configurable por ambiente
  endpoints: {
    sendMessage: '/dev/v1/message/send-synchronous',
    messageStatus: '/message/status',
    conversationHistory: '/conversation/history',
    agentInfo: '/agent/info',
    health: '/'
  },
  
  // Configuración de headers por defecto
  defaultHeaders: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  
  // Timeouts
  timeouts: {
    request: 30000, // 30 segundos
    response: 30000  // 30 segundos
  },
  
  // Configuración de reintentos
  retry: {
    maxRetries: 3,
    retryDelay: 1000 // 1 segundo
  }
};

// Reasoning Agent Configuration (AI Copilot)
export const REASONING_AGENT_CONFIG = {
  baseURL: 'https://langgraph-service-test-1-ed45ba9e3d2d5f88bb9024fce145d1bc.us.langgraph.app',
  apiKey: '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',
  agentName: 'reasoning',
};

// Función helper para construir URLs completas
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.baseURL}${endpoint}`;
};

// Función helper para obtener headers con autenticación
export const getAuthHeaders = (additionalHeaders = {}) => {
  const token = tokenService.getToken();
  
  return {
    ...API_CONFIG.defaultHeaders,
    ...(token && { 'Authorization': `${token}` }),
    ...additionalHeaders
  };
};
